import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT, Environment, Survey } from '@domains';

import { BaseApiService } from '../base-api.service';

@Injectable({
  providedIn: 'root',
})
export class SurveyService extends BaseApiService<Survey> {
  constructor(
    @Inject(ENVIRONMENT) override config: Environment,
    override http: HttpClient,
  ) {
    super(config, http, 'surveys', Survey, 'Survey');
  }
}
